import { get, post, put, del } from '@api/request';

export async function fetchCodeFile(
  { conferenceService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${conferenceService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchChimeConference(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function joinChimeConference(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/createjoinmeeting`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchCurrentConferences(
  { conferenceService },
  authenticationToken,
  { page = 1, pageSize = 40, meetingType = null },
) {
  var url = `${conferenceService}/conference/chimeconferences?pastMeetings=0&page=${page}&pageSize=${pageSize}`;
  if (meetingType && meetingType.length) {
    url = `${url}&meetingType=${meetingType}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPastConferences(
  { conferenceService },
  authenticationToken,
  { page = 1, pageSize = 40, meetingType = null },
) {
  var url = `${conferenceService}/conference/chimeconferences?pastMeetings=1&page=${page}&pageSize=${pageSize}`;
  if (meetingType && meetingType.length) {
    url = `${url}&meetingType=${meetingType}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchCurrentHelpSessions(
  { conferenceService },
  authenticationToken,
  { page = 1, pageSize = 40 },
) {
  const url = `${conferenceService}/conference/chimeconferences?pastMeetings=0&page=${page}&pageSize=${pageSize}&meetingType=HelpDesk`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPastHelpSessions(
  { conferenceService },
  authenticationToken,
  { page = 1, pageSize = 40, meetingType = null },
) {
  var url = `${conferenceService}/conference/chimeconferences?pastMeetings=1&page=${page}&pageSize=${pageSize}`;
  if (meetingType && meetingType.length) {
    url = `${url}&meetingType=${meetingType}`;
  } else {
    url = `${url}&meetingType=HelpDesk`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createChimeConference(
  { conferenceService },
  authenticationToken,
  { payload },
) {
  const url = `${conferenceService}/conference/chimeconferences`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAttendeeHistory(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/attendeehistory`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function endChimeConference(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/endmeeting`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function endAppealPanelConference(
  { conferenceService },
  authenticationToken,
  { panelID, payload },
) {
  const url = `${conferenceService}/prodigyappeals/appealpanel/${panelID}/endmeeting`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function dialOut(
  { conferenceService },
  authenticationToken,
  { conferenceID, payload },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/dialout`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAttendees(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/attendees`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAttendeeById(
  { conferenceService },
  authenticationToken,
  { conferenceID, attendeeId },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/attendee/${attendeeId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function removeAttendeeFromConference(
  { conferenceService },
  authenticationToken,
  { conferenceID, attendeeId },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/chimesattendee/${attendeeId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateAttendeeCapabilities(
  { conferenceService },
  authenticationToken,
  { conferenceID, attendeeId, payload },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/attendee/${attendeeId}/updatecapabilities`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchSpportCallInNumber(
  { conferenceService },
  authenticationToken,
) {
  const url = `${conferenceService}/conference/chimeconference/support/callinnumber`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPermissionChecks(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/permissionchecks`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function startRecording(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/startrecording`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function startHearing(
  { conferenceService },
  authenticationToken,
  { checkInPropertyID },
) {
  const url = `${conferenceService}/conference/waitingroom/checkinproperty/${checkInPropertyID}/starthearing`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function startHearingInformal(
  { conferenceService },
  authenticationToken,
  { checkInPropertyID },
) {
  const url = `${conferenceService}/conference/waitingroom/checkinproperty/${checkInPropertyID}/starthearinginformal`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function startRecordingAppeal(
  { conferenceService },
  authenticationToken,
  { conferenceID, appealID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/appeal/${appealID}/startrecording`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function endRecording(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/endrecording`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function endHearing(
  { conferenceService },
  authenticationToken,
  { checkInPropertyID },
) {
  const url = `${conferenceService}/conference/waitingroom/checkinproperty/${checkInPropertyID}/endhearing`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function endHearingInformal(
  { conferenceService },
  authenticationToken,
  { checkInPropertyID },
) {
  const url = `${conferenceService}/conference/waitingroom/checkinproperty/${checkInPropertyID}/endhearinginformal`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function endAppealRecording(
  { conferenceService },
  authenticationToken,
  { conferenceID, appealID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/appeal/${appealID}/endrecording`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export const downloadConferenceRecording = async (
  { conferenceService },
  authenticationToken,
  { conferenceID, s3ID },
) => {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/downloadrecording`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then((response) => {
      return response.text();
    })
    .then((blobby) => {
      anchor.href = `${blobby.replace(/"/g, '')}`;
      anchor.download = `${s3ID}.mp4`;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.parentNode.removeChild(anchor);
    });
};

export async function sendMeetingInfo(
  { conferenceService },
  authenticationToken,
  { conferenceID, payload },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/sendmeetinginfo`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchMeetingInformation(
  { conferenceService },
  authenticationToken,
  { conferenceID },
) {
  const url = `${conferenceService}/conference/chimeconference/${conferenceID}/meetinginformation`;
  const { body } = await get(authenticationToken, url);
  return body;
}
